export default __webpack_public_path__ + "static/media/help5.a18988a9.png";